<template>
 <div id="dWrap">
   <div id="dle">
     <br>
      <div><input type="file" value="Izaberi fajlove" name="images[]" accept="image/*" @change="setPhotoFiles($event.target.name, $event.target.files)" multiple></div>
      <hr>
      <div><vue-cropper v-for="(item, index) in imgList" :key="index" style="width: 500px;height: 302px; margin-bottom: 20px" ref="cropper" :crop-box-resizable="true"  :src="item" :auto-crop-area="1" :center="true" :movable="false" :rotatable="false" :scalable="false" :zoomable="false" :aspect-ratio="1000 / 604" :view-mode="0" alt="Source Image"></vue-cropper></div>
   </div>
   <div id="dri">
     <br>
     <table>
       <tr>
         <td>Naziv</td><td><input v-model.lazy="naziv"></td>
       </tr>
       <tr>
         <td>Kategorija</td><td><select v-model="kid">
            <option v-for="(item, index) in katList" :key="index" :value="item.kategorija_id">{{item.kategorija_naziv}}</option>
            </select>
          </td>
        </tr>
        <tr>
         <td>Podkategorija</td><td><select v-model="pid">
            <option v-for="(item, index) in podKat" :key="index" :value="item.podkat_id">{{item.podkat_naziv}}</option>
            </select></td>
        </tr>
        <tr>
         <td>Dobavljač</td><td><select v-model="did">
            <option v-for="(item, index) in dobList" :key="index" :value="item.dobavljac_id">{{item.dobavljac_naziv}}</option>
            </select></td>
        </tr>
        <tr>
         <td>Akcija</td><td><input v-model.lazy="akcija" type="checkbox" style="width:inherit; transform: scale(1.5);"/></td>
      </tr>
       <tr>
         <td>Cijena</td><td><input v-model.lazy="cijena"></td>
      </tr>
       <tr>
         <td>Boja</td><td><input v-model.lazy="boje"></td>
       </tr>
       <tr>
         <td>Opis</td><td><ejs-richtexteditor v-model="opis"></ejs-richtexteditor></td>
       </tr>
       <tr>
         <td>Tagovi</td><td><textarea v-model.lazy="tagovi" style="height: 80px;"></textarea></td>
       </tr>
     </table>
     <br>
     <button @click="initSave()">Sačuvaj</button>
   </div>
      <div id="loader" v-if="saving">
        <div id="status">
          <div><img src="../assets/spinner.gif" style="height: 42px; margin-right: 10px; position: relative;"> Čuvanje u toku...</div>
        </div>
      </div>
 </div>
</template>
<script>
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'
import Vue from 'vue'
import { RichTextEditorPlugin, Toolbar, Link, Image, Count, HtmlEditor, QuickToolbar } from '@syncfusion/ej2-vue-richtexteditor'
Vue.use(RichTextEditorPlugin)

export default {
  name: 'AdminNovi',
  components: {
    VueCropper
  },
  provide: {
    richtexteditor: [Toolbar, Link, Image, Count, HtmlEditor, QuickToolbar]
  },
  data () {
    return {
      imgList: [],
      showImg: [],
      katList: [],
      podkatList: [],
      dobList: [],
      naziv: '',
      opis: '',
      akcija: 0,
      cijena: '',
      tagovi: '',
      kid: -1,
      pid: -1,
      did: -1,
      saving: false,
      boje: ''
    }
  },
  created () {
    this.loadDbs()
  },
  methods: {
    setPhotoFiles (fieldName, fileList) {
      fileList.forEach((item, idx) => {
        var reader = new FileReader()
        reader.onload = (e) => {
          this.imgList.push(e.target.result)
        }
        reader.readAsDataURL(item)
      })
    },
    cropImages () {
      this.showImg = []
      this.$refs.cropper.forEach((item) => {
        this.showImg.push(item.getCroppedCanvas({ width: 1000, fillColor: '#fff' }).toDataURL('image/jpeg', 0.5))
      })
    },
    async loadDbs () {
      const response = await fetch('https://vndnamjestaj.me/kaodbs.php')
      const data = await response.json()
      this.katList = data[0]
      this.podkatList = data[1]
      this.dobList = data[2]
    },
    async initSave () {
      this.cropImages()
      var req = JSON.stringify({
        naziv: this.naziv,
        kat: this.kid,
        podkat: this.pid,
        dob: this.did,
        opis: this.opis,
        akcija: this.akcija,
        cijena: this.cijena,
        tagovi: this.tagovi,
        brojs: this.brojs,
        imgList: this.showImg,
        boje: this.boje
      })

      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: req
      }

      const response = await fetch('https://vndnamjestaj.me/additem.php', requestOptions)
      const data = await response.json()
      if (data.id > 0) {
        alert('Uspješno dodat artikal')
        window.location.reload()
      } else {
        alert('Greška pri dodavanju artikla...')
      }
    }
  },
  computed: {
    podKat () {
      return this.podkatList.filter(el => el.podkat_kid === this.kid)
    },
    brojs () {
      return this.showImg.length
    }
  }
}
</script>

<style lang="scss" scoped>

#loader{
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: RGBA(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

#loader > div{
  width: 300px;
  height: 100px;
  background-color: #fff;
  border-radius: 10px;
  padding: 10px;
}

#loader div{
  display: flex;
  justify-content: center;
  align-items: center;
}

input{
  width: 230px;
  padding: 5px;
}

select{
  width: 230px;
  padding: 5px;
}

textarea{
  width: 300px;
  height: 150px;
  padding: 5px;
}

button{
  padding: 10px 20px;
}

tr{
  height: 35px;
}
td:nth-child(1){
  text-align: right;
  padding-right: 5px;
}
td:nth-child(2){
  text-align: left;
}
#dWrap{
  position: relative;
  width: 1205px;
  height: 100vh;
  background-color: #fefefe;
  display: flex;
  margin: 0px auto;
  padding: 2vw 0px 0px;
}
#dle{
  position: relative;
  width: 600px;
  height: 95%;
  background-color: #fff;
  margin: 0px 3%;
  padding: 0px 50px;
  overflow: auto;
}
#dri{
  position: relative;
  width: 500px;
  height: 100%;
  background-color: #fff;
  padding: 20px;
}
</style>
